import { useContext, useEffect, useState } from "react";
import Banner from "./banner";
import ContinueProcess from "./continue-process";
import CoverageCards from "./coverage-cards";
import CircleCard from "./circle-card";
import Questions from "./questions";
import SliderHome from "./slider";
import SliderClients from "./slider-clients";

// @styles
import "./styles.scss";
import Context from "context/appContext";
import SectionProgress from "./section-progress";

export default function Homepage({ data, handleChange, loadBtn }) {
  const [benefitsByMonth, setBenefitsByMonth] = useState([]);
  const {
    tokenInfo,
  } = useContext(Context);
  useEffect(() => {
    if (data && data.length > 0) {
      const bnftsArry = [];
      const benefits = { periodicity: "", tabTitle: "", items: [] };
      data.forEach((item) => {
        if (item.slice_type === "beneficios_x_antiguedad") {
          let copy = { ...benefits };
          copy.periodicity = item.primary.meses;
          copy.tabTitle = `${item.primary.meses} ${item.primary.meses == 1 ? " Mes" : " Meses"
            }`;
          copy.items = item.items;
          bnftsArry.push(copy);
        }
      });
      setBenefitsByMonth(bnftsArry);
    }
  }, [data]);

  const component = (item) => {
    if (item) {
      switch (item.slice_type) {
        case "banner":
          return (
            <>
              <Banner data={item} handleChange={handleChange} />{" "}
              <SectionProgress />
            </>
          );
        case "caracteristicas":
          return <CircleCard data={item} />;
        case "continuar_proceso":
          return (
            <ContinueProcess
              data={item}
              handleChange={handleChange}
              loadBtn={loadBtn}
            />
          );
        case "_por_que_sura_":
          return <SliderHome data={item} />;
        case "coberturas":
          return <CoverageCards data={item} />;
        case "nuestros_clientes":
          return (
            <div className="homepage__container-wh">
              <SliderClients data={item} />
            </div>
          );
        case "preguntas":
          return <Questions data={item} handleChange={handleChange} />;
        default:
          return null;
      }
    }
  };

  return (
    <>
      <div className='slider-scrolling'>
        {data && tokenInfo && tokenInfo.usuarioId ? (
          <div className="homepage__container" key={0}>
            <Banner data={data[0]} handleChange={handleChange} />
          </div>
        ) : (
          data &&
          data.map((item, index) => (
            <div className="homepage__container" key={index}>
              {component(item)}
            </div>
          ))
        )}
      </div>
    </>
  );
}
